<template>
  <div class="w-100">
    <div class="mt-3 d-flex align-self-start">
      <div
        class="position-relative align-self-center d-flex align-items-center align-self-center"
      >
        <div
          class="circle-number d-flex justify-content-center align-items-center"
          style="z-index: 1"
        >
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="pl-3 d-flex">
        <div class="align-self-start mt-1">
          <h2 class="size-1_4 m-0 pb-1">
            <strong v-text="$ml.get('settings')">Configuração</strong>
          </h2>
          <p class="d-flex align-items-center">
            <span
              class="align-self-center"
              v-text="$ml.get('theseSettingsDirectlyImpactTheAccessOfExperts')"
            >
              Essas configurações impactam diretamente no acesso dos
              especialistas.
            </span>
          </p>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>
    <!-- Tipo de programa -->
    <div class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div v-if="!programEdit" class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('programType')">Tipo de Programa</label>
              <multiselect
                :value="typeProgram"
                @input="onChange"
                :allow-empty="false"
                label="name"
                :options="selectProgram"
                :custom-label="nameLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$ml.get('program')"
              >
              </multiselect>
              <transition name="fade">
                <label v-if="errorTypeProgram" class="lblError"
                  >Selecione o tipo de programa</label
                >
              </transition>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="d-flex flex-column w-100 mr-3">
        <div class="d-flex pl-3 w-100 pr-3">
          <div class="row w-100 d-flex">
            <div class="col-24 col-md-17 col-lg-9">
              <div class="form-group">
                <h6
                  v-if="typeProgram.id == 'public'"
                  v-text="$ml.get('ccpProgPubli')"
                >
                  Programa Público
                </h6>
                <h6
                  v-else-if="typeProgram.id == 'vdp'"
                  v-text="'Vulnerability Disclosure Program'"
                >
                  VDP
                </h6>
                <h6 v-else v-text="$ml.get('ccpProgPriv')">Programa Privado</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Programa por objetivo -->
    <div v-if="typeProgram.id != 'vdp'" class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div v-if="!programEdit" class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <div class="row w-100">
                <label class="pr-2">
                  {{ $ml.get("programByObjective") }}
                </label>
                <label class="switch">
                  <input type="checkbox" v-model="programByObjective" />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="vpn_required" class="d-flex align-self-start h-profile-circle">
      <div class="circle d-flex justify-content-center flex-row pt-3">
        <span class="circle-internal d-flex justify-content-center">
          <span class="circle-primary"></span
        ></span>
        <div class="h-line pt-3"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3 pl-3 pt-3">
        <div class="col-14 pb-1 d-flex row align-items-center">
          <h6>Este programa possui VPN</h6>
          <!-- <VueCustomTooltip label="VPN">
            <span class="ico ico-vpn ml-2">
              <img src="../../../assets/images/vpn.png" />
            </span>
          </VueCustomTooltip>  -->
        </div>
      </div>
    </div>

    <!-- Ranking type-->
    <div
      class="d-flex align-self-start h-profile-circle"
      v-if="typeProgram.id == 'private' && !programEdit && hallOfFamePermission"
    >
      <div class="v-line"><span></span></div>
      <div class="circle d-flex justify-content-center flex-row mt-3">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div
        v-if="!programEdit && hallOfFamePermission"
        class="d-flex flex-column w-100 mr-3 mt-3"
      >
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('setHallOfFame')"
                >Você deseja ativar o hall da fama em seu novo programa?</label
              >
              <multiselect
                :value="hofActive"
                @input="onChangeHof"
                :allow-empty="false"
                label="name"
                :options="selectYesNo"
                :custom-label="yesNoLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
              <transition name="fade">
                <label v-if="errorTypeProgram" class="lblError"
                  >Selecione o tipo do ranking</label
                >
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="d-flex align-self-start h-profile-circle"
      v-if="typeProgram.id == 'private' && !programEdit && contractAllowNDA"
    >
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div
        v-if="!programEdit && contractAllowNDA"
        class="d-flex flex-column w-100 mr-3"
      >
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('setProgramNda')"
                >Você deseja adicionar o contrato de confidencialidade ao seu
                novo programa?</label
              >
              <multiselect
                :value="ndaRequired"
                @input="onChangeNda"
                :allow-empty="false"
                label="name"
                :options="selectYesNo"
                :custom-label="yesNoLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
              <transition name="fade">
                <label v-if="errorTypeProgram" class="lblError"
                  >Selecione o tipo de programa</label
                >
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Require VPN -->
    <div
      class="d-flex align-self-start h-profile-circle"
      v-if="typeProgram.id == 'private' && !programEdit && contractAllowVPN"
    >
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center">
          <span class="circle-primary"></span>
        </span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>

      <div class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('doYouWantToAddVPNToYourNewProgram')">
                Você deseja adicionar VPN ao seu novo programa?</label
              >
              <multiselect
                :value="vpnRequired"
                @input="onChangeVpn"
                :allow-empty="false"
                label="name"
                :options="selectYesNo"
                :custom-label="yesNoLang"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
              >
              </multiselect>
              <transition name="fade">
                <label v-if="errorTypeProgram" class="lblError"
                  >Selecione o tipo de programa</label
                >
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <!-- Slug de programa -->
    <div
      v-if="['vdp', 'public'].includes(typeProgram.id)"
      class="d-flex align-self-start h-profile-circle"
    >
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100 mr-3">
        <div class="row w-100 d-flex pl-3 pr-3">
          <div class="col-24 col-md-17 col-lg-9">
            <div class="form-group">
              <label v-text="$ml.get('directoryName')">Nome do Diretório</label>
              <input
                v-if="pageEdit"
                v-mask="customSlug"
                maxlength="25"
                class="form-control"
                :value="slug"
                @input="$emit('update:slug', $event.target.value)"
                :placeholder="$ml.get('theNameWillBeAssignedToYourProgramsURL')"
              />
              <p class="p-1 m-0">{{ url }}/{{ slug }}</p>
              <transition name="fade">
                <label
                  v-if="errorSlug && this.slug.length < 2"
                  class="lblError"
                  v-text="$ml.get('requiredField')"
                  >Campo obrigatório</label
                >
              </transition>
              <div style="height: 20px;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="['public', 'private'].includes(typeProgram.id) && !programByObjective"
      class="d-flex align-self-start h-profile-circle"
    >
      <div class="circle d-flex justify-content-center flex-row">
        <span class="circle-internal d-flex justify-content-center"
          ><span class="circle-primary"></span
        ></span>
        <div class="h-line"><span></span></div>
        <div class="v-line"><span></span></div>
      </div>
      <div class="d-flex flex-column w-100">
        <div class="row w-100 d-flex pl-3">
          <div class="w-100">
            <table>
              <div class="col-24">
                <div class="row w-100">
                  <label class="pr-2">
                    {{ $ml.get("titleBudgetActive") }}
                  </label>
                  <label class="switch">
                    <input
                      type="checkbox"
                      v-model="budgetRegistration.activateBudget"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>

              <tbody v-show="budgetRegistration.activateBudget">
                <tr class="mb-1 py-1">
                  <td class="col-16 d-flex align-items-center">
                    <label>{{ $ml.get("budgetLimitProgram") }}</label>
                  </td>
                  <td
                    class="col-8 p-0 px-2 d-flex align-items-center"
                    style="position: relative"
                  >
                    <label class="currency" v-if="currency === 'BRL'">R$</label>
                    <label class="currency dolar" v-else>US$</label>
                    <money
                      class="form-control mask-real"
                      v-model.number="budgetRegistration.budgetValue"
                      :placeholder="placeholderMoney"
                      maxLength="20"
                    />
                    <transition name="fade">
                      <label
                        v-if="budgetMessageError?.budgetValue"
                        class="lblError p-lblError"
                        v-text="$ml.get('errorValueBudget')"
                      >
                        {{ $ml.get("errorBudgetLimit") }}
                      </label>
                      <label
                        v-if="budgetRegistration.budgetValue < 0"
                        class="lblError p-lblError"
                        v-text="$ml.get('labelCurrencyValue')"
                      >
                        {{ $ml.get("invalidValueBudget") }}
                      </label>
                    </transition>
                  </td>
                </tr>
                <tr class="mb-1 py-1">
                  <td class="col-16 d-flex align-items-center">
                    <label>{{ $ml.get("notificationBudget") }}</label>
                  </td>
                  <td class="col-8 py-2 p-0 px-2">
                    <input
                      class="px-2 form-control"
                      type="text"
                      v-model.number="budgetRegistration.notification"
                      placeholder="70%"
                      maxlength="3"
                    />
                    <div class="col-24">
                      <transition name="fade">
                        <label
                          v-if="budgetMessageError?.notification"
                          class="lblError"
                          v-text="$ml.get('errorBudgetNotification')"
                        >
                          {{ $ml.get("percentageBudget") }}
                        </label>
                        <label
                          v-if="
                            budgetRegistration.notification < 0 ||
                            budgetRegistration.notification > 100
                          "
                          class="lblError p-lblError"
                          v-text="$ml.get('labelInvalidValue')"
                        >
                          {{ $ml.get("percentageErrorBudget") }}
                        </label>
                      </transition>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="col-16 d-flex align-items-center">
                    <label>{{ $ml.get("pauseProgramBudget") }}</label>
                  </td>
                  <td class="col-8 py-2 p-0 px-2">
                    <label class="switch">
                      <input
                        type="checkbox"
                        v-model="budgetRegistration.pauseProgram"
                      />
                      <span class="slider round"></span>
                    </label>
                  </td>
                </tr>
                <tr class="py-1" v-show="budgetRegistration.pauseProgram">
                  <td class="col-16 d-flex align-items-center">
                    <label>{{ $ml.get("percentagePauseBudget") }}:</label>
                  </td>
                  <td class="col-8 py-2 p-0 px-2">
                    <input
                      class="px-2 form-control"
                      type="text"
                      v-model.number="budgetRegistration.breakPercentage"
                      placeholder="90%"
                      maxlength="3"
                    />
                    <div class="col-24">
                      <transition name="fade">
                        <label
                          v-if="budgetMessageError?.breakPercentage"
                          class="lblError"
                          v-text="$ml.get('errorBudgetNotification')"
                        >
                          Informe o percentual desejado
                        </label>
                        <label
                          v-if="
                            budgetRegistration.breakPercentage < 0 ||
                            budgetRegistration.breakPercentage > 100
                          "
                          class="lblError p-lblError"
                          v-text="$ml.get('labelInvalidValue')"
                        >
                          {{ $ml.get("percentageErrorBudget") }}
                        </label>
                      </transition>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-self-start h-profile">
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>

    <div
      v-if="['vdp', 'public', 'private'].includes(typeProgram.id)"
      class="d-flex align-self-start h-profile"
    >
      <div class="v-line d-flex align-items-stretch">
        <span class="pb-4"></span>
      </div>
    </div>
  </div>
</template>
<script>
import planService from "../../../services/plan.service";
export default {
  name: "Config",
  props: {
    number: {
      type: String,
      required: true,
    },
    typeProgram: {
      type: Object,
      required: false,
    },
    activeObjective: {
      type: Boolean,
      required: false,
    },
    ndaRequired: {
      type: Object,
      required: false,
    },
    vpnRequired: {
      type: Object,
      required: false,
    },
    vpn_required: {
      type: Boolean,
      required: false,
    },
    hofActive: {
      type: Object,
      required: false,
    },
    programEdit: {
      type: Boolean,
      required: false,
    },
    slug: {
      type: String,
      required: false,
      default: "",
    },
    errorSlug: {
      type: Boolean,
      required: true,
    },
    errorTypeProgram: {
      type: Boolean,
      required: false,
    },
    pageEdit: {
      type: Boolean,
      required: false,
      default: true,
    },
    dataBudget: {
      type: Function,
      required: false,
      default: () => {},
    },
    budgetMessageError: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  components: {},
  data() {
    return {
      programByObjective: false,
      selectProgram: [
        { id: "public", name: "public" },
        { id: "private", name: "private" },
        { id: "vdp", name: "VDP" },
      ],
      selectYesNo: [
        { id: "no", name: "no" },
        { id: "yes", name: "yes" },
      ],
      customSlug: {
        mask: "CCCCCCCCCCCCCCCCCCCCCCCCC",
        tokens: {
          C: {
            pattern: /[0-9a-zA-Z-]/,
            transform: function (v) {
              return v.toLocaleLowerCase();
            },
          },
        },
      },
      url: window.location.origin,
      contractAllowNDA: false,
      contractAllowVPN: false,
      hallOfFamePermission: false,
      budgetRegistration: {
        activateBudget: false,
        pauseProgram: false,
        notification: null,
        budgetValue: 0,
        breakPercentage: null,
      },
      currency:"",
    };
  },

  mounted() {
    this.currency = this.$store.getters['getUser'].currency;
    this.checkPlanPermission();
  },
  watch: {
    budgetRegistration: {
      handler(newValue) {
        this.dataBudget(newValue);
      },
      deep: true,
    },
    typeProgram: {
      handler() {
        if(this.typeProgram.id === 'vdp'){
          this.programByObjective = false;
        }
      },
      deep: true,
    },
    activeObjective: {
      handler() {
        if(this.activeObjective === true){
          this.programByObjective = true;
        }
      },
      deep: true,
    },
    
    programByObjective() {
      this.$emit("programByObjective", {
        programByObjective: this.programByObjective,
      });

      if(this.programByObjective){
        this.selectProgram = this.selectProgram.filter(item => item.id != 'vdp') 
        return      
      }

      if(this.selectProgram.length === 2 ){
        this.selectProgram.push(
          {
            id: "vdp", name: "VDP" 
          }
        )
      }

    },
  },
  computed:{
    placeholderMoney(){
      return this.currency === 'BRL' ? 'R$ 0,00' : '$ 0,00'
    }
  },
  methods: {
    async checkPlanPermission() {
      await planService
        .getCurrentPlanByCompany(`can_request_special_agreement_therms`)
        .then(
          (response) => {
            if (response.data) {
              this.contractAllowNDA =
                response.data.can_request_special_agreement_therms;
              this.contractAllowVPN = response.data.can_request_vpn_access;
              this.hallOfFamePermission =
                response.data.private_program_hall_of_fame;
            }
          },
          (error) => {
            console.dir(error);
          },
        );
    },
    onChange(typeProgram) {
      this.$emit("verify-Plan", typeProgram);
    },
    onChangeNda(ndaRequired) {
      this.$emit("set-Nda", ndaRequired);
    },
    onChangeVpn(vpnRequired) {
      this.$emit("set-Vpn", vpnRequired);
    },
    onChangeHof(hofActive) {
      this.$emit("set-Hof", hofActive);
    },
    nameLang({ name }) {
      if (name == "public") {
        return this.$ml.get("ccpProgPubli");
      }
      if (name == "private") {
        return this.$ml.get("ccpProgPriv");
      }
      if (name == "VDP") {
        return "VDP";
      }
    },
    yesNoLang({ name }) {
      var self = this;
      if (name == "no") {
        return self.$ml.get("no");
      } else if (name == "yes") {
        return self.$ml.get("yes");
      }
    },
  },
};
</script>
<style scoped>
.currency {
  position: absolute;
  top: 50%;
  left: 3.5%;
  transform: translate(50%, -50%);
  font-weight: 400;
  color: #495057;
}
.dolar{
  left: 1.5%;
}
.input-custom {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0px;
  width: 150px;
  height: 15px;
}
.p-lblError {
  position: absolute;
  top: 82%;
}
</style>
